// extracted by mini-css-extract-plugin
export default {"button":"eq-z","reviewSort":"fq-z"};